module.exports = __webpack_public_path__ + "img/76141.72fb2285.svg";